(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('.wm-store-menu-link');
    if (!link) return;
    const destination = new URL(link.href);
    if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search) return;
    const target = document.getElementById('wm-ajman-store');
    const drawer = link.closest('header-drawer');
    const summary = drawer?.querySelector('summary');
    const details = drawer?.querySelector('details');
    if (target && summary && details?.open) {
      const focusDestination = () => {
        if (details.open) return;
        details.removeEventListener('toggle', focusDestination);
        target.focus({ preventScroll: true });
      };
      details.addEventListener('toggle', focusDestination);
      summary.click();
      target.focus({ preventScroll: true });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
